import { DatePicker as ArkUiDatePicker } from "@ark-ui/react";

export default function isFocusedDate(
  date: ArkUiDatePicker.DateValue,
  focusedDate?: ArkUiDatePicker.DateValue,
): boolean {
  return (
    focusedDate?.year === date.year &&
    focusedDate?.month === date.month &&
    focusedDate?.day === date.day
  );
}
